import * as React from 'react'
import { getTemplateSelectedAction } from '@/actions/templates/get-templates'
import { showErrorToast } from '@/components/ui/custom-toasts'
import { useChatManagerStore } from '../../store/use-chat-manager-store'
import { usePromptTemplatesStore } from '@/lib/store/use-prompt-templates-store'

export const fetchTemplateSelectedAction = async (templateId: string) => {
  const templateSelectedActionData = await getTemplateSelectedAction({
    templateId,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  })
  if (!templateSelectedActionData || !templateSelectedActionData.data) {
    console.error('Error fetching templateSelectedAction:', templateSelectedActionData)
          showErrorToast(`Something went wrong getting the selected prompt, please try again.`)
    return
  }
  return templateSelectedActionData.data
}

interface UsePromptTemplateRunOnAppLoadProps {
  handleOpenSelectFilesModal: () => Promise<void>
}

export function usePromptTemplateRunOnAppLoad({
  handleOpenSelectFilesModal,
}: UsePromptTemplateRunOnAppLoadProps) {
  const setShowThinking = useChatManagerStore((store) => store.setShowThinking);
  const setLlmThinkingEnabled = useChatManagerStore((store) => store.setLlmThinkingEnabled);
  const setRunPromptTemplate = useChatManagerStore((store) => store.setRunPromptTemplate);
  const fileIds = useChatManagerStore((store) => store.fileIds);
  const setPromptTemplateSelected = usePromptTemplatesStore((store) => store.setPromptTemplateSelected);
  const setIsLoadingRunTemplate = usePromptTemplatesStore((store) => store.setIsLoadingRunTemplate);
  const initialTemplateId = usePromptTemplatesStore((store) => store.initialTemplateId);
  const setInitialTemplateId = usePromptTemplatesStore((store) => store.setInitialTemplateId);

  React.useEffect(() => {
    if (!initialTemplateId) {
      return
    }

    const fetchAndSetPromptTemplateToRun = async () => {
      if (useChatManagerStore.getState().runPromptTemplate?.id === initialTemplateId) {
        return
      }

      const result = await fetchTemplateSelectedAction(initialTemplateId)
      if (!result) {
        return
      }
      if (result.requestDocument && !fileIds.length) {
        setPromptTemplateSelected({ id: initialTemplateId, requestDocument: true })
        handleOpenSelectFilesModal()
        return
      }
      setIsLoadingRunTemplate(false)
      setShowThinking(true)
      setLlmThinkingEnabled(false)
      useChatManagerStore.getState().setShowThinkingMessageIndex(1)
      setRunPromptTemplate({ id: initialTemplateId, name: result.templateName || '', disableAutoRun: result.disableAutoRun, prompt: result.prompt })
    }

    fetchAndSetPromptTemplateToRun()
  }, [initialTemplateId, fileIds, setShowThinking, setLlmThinkingEnabled, setInitialTemplateId, setIsLoadingRunTemplate, setPromptTemplateSelected, setRunPromptTemplate, handleOpenSelectFilesModal])
}
